import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';
import html2canvas from 'html2canvas';

Vue.component('client-stats', {
    props: ['default-start', 'default-to'],

    components: {
        datePicker
    },

    data () {
        return {
            dates: {
                from: moment().startOf('today').format("DD-MM-YYYY"),
                to: moment().endOf('today').format("DD-MM-YYYY")
            },

            dashboardData: {},

            loading: false,
            pdfLoading: false,
            activityLoading: false,
            logsLoading: false,
            remindersLoading: false,

            reminderFilters: {
                admin: 0,
                tasks: 0,
                search: ''
            },

            autoRefresh: false,
            autoRefreshTimeout: null,

            viewingData: null,
            dataLoading: false,

            tpOptions: {
                format: 'DD-MM-YYYY'
            },

            client: 24
        };
    },

    mounted () {
        if (this.defaultStart.length > 0) {
            this.dates.from = this.defaultStart;
        }

        if (this.defaultTo.length > 0) {
            this.dates.to = this.defaultTo;
        }

        this.loadData();

        $('body').on('show.bs.collapse', '.collapse', function () {
            $(this).find('iframe').attr('src', $(this).data('load'));
        });
    },

    methods: {
        handleDateSelected (field, value) {
            // this.dates[field] = value;
        },

        communicationPercent (type) {
            const total = (Number(this.dashboardData.activity.ratio.email) + Number(this.dashboardData.activity.ratio.report)) +
                (Number(this.dashboardData.activity.ratio.linkedin) + Number(this.dashboardData.activity.ratio.note));

            return (
                (Number(this.dashboardData.activity.ratio[type]) / total) * 100) + '%';
        },

        prospectsPercent (type) {
            return ((Number(this.dashboardData.activity.ratio[type]) / (Number(this.dashboardData.activity.ratio.prospects) + Number(this.dashboardData.activity.ratio.sales))) * 100) + '%';
        },

        loadData () {
            this.loading = true;

            const { from, to } = this.dates;

            axios.get('/api/dashboard', {
                params: {
                    from,
                    to,
                    client_id: this.client
                }
            }).then((response) => {
                this.dashboardData = response.data;

                this.loading = false;

                window.clearTimeout(this.autoRefreshTimeout);

                if (this.autoRefresh) {
                    this.autoRefreshTimeout = setTimeout(() => {
                        this.loadData();
                    }, (10 * 60 * 1000));
                }
            });
        },

        autoRefreshToggle () {
            this.autoRefresh = !this.autoRefresh;

            this.loadData();
        },

        setActivityRange (range) {
            this.activityLoading = true;

            const { from, to } = this.dates;

            axios.get('/api/dashboard/activity', {
                params: {
                    from,
                    to,
                    acRange: range
                }
            }).then((response) => {
                this.dashboardData.activity = response.data;

                this.activityLoading = false;
            });
        },

        getLogs (page) {
            this.logsLoading = true;

            const { from, to } = this.dates;

            axios.get('/api/dashboard/logs', {
                params: {
                    from,
                    to,
                    page
                }
            }).then((response) => {
                this.dashboardData.logs = response.data;

                this.logsLoading = false;
            });
        },

        filterReminders () {
            this.remindersLoading = true;

            axios.get('/api/dashboard/reminders', {
                params: {
                    ...this.reminderFilters
                }
            }).then((response) => {
                this.dashboardData.reminders = response.data;

                this.remindersLoading = false;
            });
        },

        exportPdf () {
            this.pdfLoading = true;

            window.scrollTo(0, 0);

            $('#stats').css({
                padding: '20px',
                width: '1200px',
                position: 'fixed',
                top: 0,
                left: 0
            });
            $('.hide-pdf').hide();

            var currentHeight = 0;
            var limit = 1685;

            $('#stats').find('> div').each(function () {
                if (!$(this).hasClass('hide-pdf')) {
                    if ((currentHeight + $(this).height()) < limit) {
                        currentHeight += $(this).height();
                    } else {
                        var padding = limit - currentHeight;

                        currentHeight = $(this).height();
                        $(this).css('padding-top', padding + 'px');
                    }
                }
            });

            html2canvas(document.querySelector('#stats'), {
                scrollX: 0,
                scrollY: -window.scrollY
            }).then((canvas) => {
                var imgData = canvas.toDataURL("image/jpeg", 1.0);

                var imgWidth = 210;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;

                var doc = new jsPDF('p', 'mm');
                var position = 0;

                doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save('introfer-stats.pdf');

                $('#stats').css({
                    padding: '0',
                    width: '100%',
                    position: 'relative'
                });
                $('#stats').find('> div').css('padding-top', '0');
                $('.hide-pdf').show();

                this.pdfLoading = false;
            });
        },

        viewData (type, id, admin) {
            this.viewingData = {
                type,
                admin
            };

            $('#view-data').modal('show');

            this.dataLoading = true;

            axios.get('/api/dashboard/view_data', {
                params: {
                    type,
                    id,
                    ...this.dates
                }
            }).then((response) => {
                this.dataLoading = false;
                this.viewingData.data = response.data;
            });
        },

        loadComs (item) {
            this.viewingData.data[item].load = true;
        }
    },

    filters: {
        date (value) {
            return moment(value).format("DD/MM/YYYY HH:mm");
        }
    },

    computed: {
        adminDashboardData () {
            if (!this.dashboardData.admins) {
                return [];
            }

            var i, j, newArray = [], chunk = 4;

            for (i = 0, j = this.dashboardData.admins.length; i < j; i += chunk) {
                newArray.push(this.dashboardData.admins.slice(i, i + chunk));
                // do whatever
            }

            return newArray;
        }
    }
});